import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { Button } from 'antd';
import { usePlausible } from 'next-plausible';
import { useRouter } from 'next/router';
import { useContext } from 'react';

export default function SongButtons({ activity }) {
  const globalContext = useContext(GlobalContext);
  const router = useRouter();
  const plausible = usePlausible();
  function onDownload() {
    plausible('download', {
      props: {
        title: activity.englishName,
        type: activity.type,
        pageUrl: router.asPath,
      },
    });
  }
  return activity.data?.lyrics &&
    ((globalContext.state.user?.teacher &&
      globalContext.state.isSubscriptionActive) ||
      activity?.free) ? (
    <Button
      type="primary"
      href={activity.data.lyrics}
      target="_blank"
      rel="noreferrer"
      onClick={onDownload}
    >
      Download song lyrics and drawings
    </Button>
  ) : null;
}
